import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { TradingPlatformServers } from '@monorepo/client-common';
import { getTradingSystemName } from '@monorepo/client-types';
import { Flex, TextComponent } from '@monorepo/react-components';
import { TradingSystem, UnavailableValue } from '@monorepo/types';

interface Props {
  login?: string;
  password?: string;
  tradingSystem: TradingSystem;
}

export const TradersLoginCard: FunctionComponent<Props> = ({
  login,
  password,
  tradingSystem,
}) => {
  const { t } = useTranslation(['login', 'programs']);

  const tradingServer = TradingPlatformServers[tradingSystem];
  const tradingPlatformName = t(
    `programs:trading_system.${tradingSystem}_hub`,
    { defaultValue: getTradingSystemName(tradingSystem) },
  );

  return (
    <Flex vertical gap={14}>
      <Flex justify="space-between">
        <TextComponent weight={600} responsive={false}>
          {t('login:traders_login.login')}
        </TextComponent>
        <TextComponent copyable={true} responsive={false}>
          {login || UnavailableValue.Dash}
        </TextComponent>
      </Flex>
      <Flex justify="space-between">
        <TextComponent weight={600} responsive={false}>
          {t('login:traders_login.password')}
        </TextComponent>
        <TextComponent copyable={true} responsive={false}>
          {password || UnavailableValue.Dash}
        </TextComponent>
      </Flex>
      <Flex justify="space-between">
        <TextComponent weight={600} responsive={false}>
          {t('login:traders_login.platform')}
        </TextComponent>
        <TextComponent copyable weight={600} responsive={false}>
          {tradingPlatformName}
        </TextComponent>
      </Flex>
      {tradingServer && (
        <Flex justify="space-between" wrap="wrap">
          <TextComponent weight={600} responsive={false}>
            {t('login:traders_login.server')}
          </TextComponent>
          <TextComponent noWrap copyable responsive={false}>
            {tradingServer}
          </TextComponent>
        </Flex>
      )}
    </Flex>
  );
};
